/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPCallArgumentsDeltaEvent = {
  type: "response.mcp_call_arguments.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  delta: string;
};

/** @internal */
export const ResponseMCPCallArgumentsDeltaEvent$inboundSchema: z.ZodType<
  ResponseMCPCallArgumentsDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_call_arguments.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPCallArgumentsDeltaEvent$Outbound = {
  type: "response.mcp_call_arguments.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  delta: string;
};

/** @internal */
export const ResponseMCPCallArgumentsDeltaEvent$outboundSchema: z.ZodType<
  ResponseMCPCallArgumentsDeltaEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPCallArgumentsDeltaEvent
> = z.object({
  type: z.literal("response.mcp_call_arguments.delta"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPCallArgumentsDeltaEventToJSON(
  responseMCPCallArgumentsDeltaEvent: ResponseMCPCallArgumentsDeltaEvent,
): string {
  return JSON.stringify(
    ResponseMCPCallArgumentsDeltaEvent$outboundSchema.parse(
      responseMCPCallArgumentsDeltaEvent,
    ),
  );
}
export function responseMCPCallArgumentsDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPCallArgumentsDeltaEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseMCPCallArgumentsDeltaEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPCallArgumentsDeltaEvent' from JSON`,
  );
}
